import { z } from "zod";

export const linkSchema = z.object({
    id: z.string().optional(),
    title: z.string().min(1, "forms.general-validation.title_required"),
    url: z.string().url("forms.offer-link-edit.validation.invalid_url"),
});

export const schema = z.object({
    links: z.array(linkSchema),
});

export type LinkFormData = z.infer<typeof linkSchema>;
export type OfferLinkEditFormData = z.infer<typeof schema>;